import React from 'react';
import moment from 'moment';
import { ReactComponent as GenericSVG } from '../../../assets/sightx-icons/svg/cards/generic.svg';
import { ReactComponent as VisaSVG } from '../../../assets/sightx-icons/svg/cards/visa.svg';
import { ReactComponent as MastercardSVG } from '../../../assets/sightx-icons/svg/cards/mastercard.svg';
import { ReactComponent as UnionPaySVG } from '../../../assets/sightx-icons/svg/cards/unionpay.svg';
import { ReactComponent as JcbSVG } from '../../../assets/sightx-icons/svg/cards/jcb.svg';
import { ReactComponent as DiscoverSVG } from '../../../assets/sightx-icons/svg/cards/discover.svg';
import { ReactComponent as DinersSVG } from '../../../assets/sightx-icons/svg/cards/diners.svg';
import { ReactComponent as AmexSVG } from '../../../assets/sightx-icons/svg/cards/amex.svg';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

enum TermsOptions {
  NET30 = 'NET30',
  NET60 = 'NET60',
  NET90 = 'NET90',
  NET120 = 'NET120',
}

interface IOption {
  label: string;
  value: TermsOptions;
}

export const InvoiceTermsOptionsSelect: ReadonlyArray<IOption> = [
  {
    label: 'Net 30',
    value: TermsOptions.NET30
  },
  {
    label: 'Net 60',
    value: TermsOptions.NET60
  },
  {
    label: 'Net 90',
    value: TermsOptions.NET90
  },
  {
    label: 'Net 120',
    value: TermsOptions.NET120
  }
];

export const toMonthDayYearFormat = (date?: Date | string): string => {
  return moment(date).format('MMMM DD, YYYY');
};

export const getSvgComponentForCreditCardBrand = (brand: string): React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>> => {
  switch (brand) {
  case 'visa':
    return VisaSVG;
  case 'mastercard':
    return MastercardSVG;
  case 'unionpay':
    return UnionPaySVG;
  case 'jcb':
    return JcbSVG;
  case 'discover':
    return DiscoverSVG;
  case 'diners':
    return DinersSVG;
  case 'amex':
    return AmexSVG;
  default:
    return GenericSVG;
  }
};
